<template>
  <div class="hello">
    	<div class="admin-logo"><img src="https://www.baibaodu.com/sinoins/2024innovate/images/big_logo_w.png" width="65%"></div>
			<div style="width:190px">
        <el-menu
          :default-active="selec"
          default-openeds="1-1" 
          class="el-menu-vertical-demo"
          background-color="#F1FAFF"
          text-color="#555555"
          active-text-color="#2C7DB4" style="width:190px">
          <el-submenu  index="1">
            <template slot="title">
              <i class="el-icon-tickets"></i>
              <span slot="title">活动列表</span>
            </template>
              <el-menu-item index="1-1" @click="$router.push('/topics')">活动</el-menu-item>
              <el-menu-item index="1-2" @click="$router.push('/topicsfile')">归档</el-menu-item>
              <el-menu-item index="1-3" @click="$router.push('/topicsrecycle')">回收站</el-menu-item>
          </el-submenu>
          <el-menu-item v-if="showPowerSet == true" index="2" @click="$router.push('/sysset')" >
            <i class="el-icon-set-up"></i>
            <span slot="title">系统设置</span>
          </el-menu-item>
           <el-menu-item  index="3" @click="$router.push('/feedback')" >
            <i class="el-icon-chat-line-round"></i>
            <span slot="title">问题反馈</span>
          </el-menu-item>
        </el-menu>
      </div>
  </div>
</template>

<script>
import * as MN from '@/api/common'
export default {
  name: 'common-nav',
  props: {
    msg: String,
    selec:String
  },
  data(){
    return{
      showPowerSet:false,
    }
  },
  created() {
		this.handleLoginUser()
	},
  methods:{
    handleLoginUser(){
      let me = this;
      let post={
					token:sessionStorage.getItem('subudian_token')
      }
      MN.loginUserdata(post).then(res => {
        if ( res.u_power == '2' ){
          me.showPowerSet = true
        }else{
          me.showPowerSet =false
        }
			})
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 0 0 0;
  
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 0;
}
a {
  color: #42b983;
}
.el-menu{
  width: 200px;
}
.el-submenu{
  width: 200px;
  border-bottom:1px solid #C8D8FF;
}
.el-menu-item .disabled{

}
.el-menu-item{
  width: 200px;
  border-bottom:1px solid #C8D8FF;
}
</style>
